import * as type from '../types/universal'

export const setFallbackMessage = payload => {
    return{
        type: type.SET_NOTIFICATION,
        message: payload
    }
}

export const resetFallbackMessage = () => {
    return{
        type: type.RESET_NOTIFICATION
    }
}

export const changeUniversalModal = payload => {
    return{
        type: type.CHANGE_UNIVERSAL_MODALS,
        modal: payload
    }
}